import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, mergeMap, Observable, tap } from 'rxjs';
import { BaseComponent } from 'src/app/_shared/components/base/base.component';
import { LoadingComponent } from 'src/app/_shared/components/loading/loading.component';
import { FaqSection } from 'src/types/graphql';
import { FaqSectionBySlugGQL } from '../faq.query.generated';
import { FaqService } from '../faq.service';
import { SafePipe } from '../../../_shared/pipes/safe.pipe';

@Component({
  selector: 'sharry-faq-body',
  templateUrl: './faq-body.component.html',
  styleUrls: ['./faq-body.component.scss'],
  standalone: true,
  imports: [AsyncPipe, SafePipe, LoadingComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqBodyComponent extends BaseComponent implements OnInit, OnDestroy {
  faqSection$: Observable<FaqSection>;
  isSearch = false;

  constructor(
    private route: ActivatedRoute,
    private faqSectionBySlugGQL: FaqSectionBySlugGQL,
    private cd: ChangeDetectorRef,
    private faqService: FaqService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.faqSection$ = this.route.params.pipe(
      mergeMap(params => this.faqSectionBySlugGQL.fetch({ slug: params?.section })),
      map(r => r.data.faqSectionBySlug as FaqSection),
      tap(faq => {
        this.faqService.setSection(faq);
        this.faqService.setArea(faq.faq);
      }),
    );
    this.subscriptions.push(
      this.route.queryParams.subscribe(params => {
        this.isSearch = params?.search === 'true';
        this.cd.detectChanges();
      }),
    );
  }

  ngOnDestroy(): void {
    this.faqService.setArea(undefined);
    this.faqService.setSection(undefined);
    super.ngOnDestroy();
  }
}
